module.exports = __webpack_public_path__ + "static/media/store-ios.eadb24db.svg";